import LessonPlanPage from "./LessonPlanPage";

export default LessonPlanPage;